<template>
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" :class="className">
        <path d="M2.5 5H4.16667H17.5" stroke="#184495" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M6.66675 4.99935V3.33268C6.66675 2.89065 6.84234 2.46673 7.1549 2.15417C7.46746 1.84161 7.89139 1.66602 8.33341 1.66602H11.6667C12.1088 1.66602 12.5327 1.84161 12.8453 2.15417C13.1578 2.46673 13.3334 2.89065 13.3334 3.33268V4.99935M15.8334 4.99935V15.4994C15.8334 15.9414 15.6578 16.3653 15.3453 16.6779C15.0327 16.9904 14.6088 17.166 14.1667 17.166H5.83341C5.39139 17.166 4.96746 16.9904 4.6549 16.6779C4.34234 16.3653 4.16675 15.9414 4.16675 15.4994V4.99935H15.8334Z" stroke="#184495" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
</template>

<script>
export default {
    name: 'IconTrash',

    props: ['className']
};
</script>

<style lang="scss">
@import "Icons";
</style>
